<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Edit Tax Rate</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5 tw-mb-3">
        <base-text-field label="Name" v-model="name" required />
        <base-text-field label="Description" v-model="description" />
        <base-text-field class="tw-mt-6" label="Jurisdiction (describes the area the tax applies to)" v-model="jurisdiction" />
        <div class="tw-flex tw-mt-4">
          <div class="tw-text-gray-700 tw-font-light tw-mr-2">Active</div>
          <base-toggle v-model="active"></base-toggle>
        </div>
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error class="tw-mt-3" id="edit-tax-rate-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import { mapActions } from "vuex";

export default {
  name: "EditTaxRate",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      taxRateId: null,
      name: null,
      description: null,
      jurisdiction: null,
      active: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    ...mapActions("businessActivation", { businessActivationInit: "init" }),
    reset() {
      this.taxRateId = null;
      this.name = null;
      this.jurisdiction = null;
      this.description = null;
      this.active = false;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.$refs.form.reset();
    },
    show(taxRate) {
      this.taxRateId = taxRate.taxRateId;
      this.name = taxRate.name;
      this.description = taxRate.description;
      this.jurisdiction = taxRate.jurisdiction;
      this.active = taxRate.active;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/taxrates/${this.taxRateId}`, {
          name: this.name,
          description: this.description,
          jurisdiction: this.jurisdiction,
          active: this.active,
        })
        .then(() => {
          this.$emit("edited");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Tax Rate Saved", message: this.name + " tax rate was saved successfully" });
          this.hide();
          this.businessActivationInit();
        })
        .catch((err) => {
          this.errorTitle = `Error editing tax rate`;
          this.errorMessage = "Sorry, we had trouble editing this tax rate. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
